import React from "react";
import { ApolloProvider } from "react-apollo";
import { ErrorResponse } from "apollo-link-error";
import { Provider as UnstatedProvider } from "unstated";

import {
  Router,
  Switch,
  Route,
  AuthRoute,
  RouterErrorBoundary,
} from "./router";
import { createApolloClient } from "./apolloClient";
import AuthContainer from "./state/AuthContainer";

import LoginScene from "./scene/login/LoginScene";
import LogoutScene from "./scene/logout/LogoutScene";
import DashboardScene from "./scene/dashboard/DashboardScene";
import UserScene from "./scene/user/UserScene";
import LicenseScene from "./scene/license/LicenseScene";
import ScenarioScene from "./scene/scenario/ScenarioScene";
import SessionScene from "./scene/session/SessionScene";

type AppProps = {};
type AppState = { authContainer: any; apolloClient: any };

class App extends React.Component<AppProps, AppState> {
  constructor(props: AppProps) {
    super(props);

    const authContainer = new AuthContainer();
    authContainer.subscribe(this.handleAuthChange);
    const auth = authContainer.getAuth();

    const apolloClient = this.createApolloClient(auth);

    this.state = {
      authContainer,
      apolloClient,
    };
  }

  createApolloClient(auth: any) {
    const apolloClient = createApolloClient({
      onNetworkError: this.handleApolloNetworkError,
      onUnauthenticatedError: this.handleUnauthenticatedError,
      auth,
    });
    return apolloClient;
  }

  handleAuthChange = () => {
    const auth = this.state.authContainer.getAuth();
    const apolloClient = this.createApolloClient(auth);
    this.setState({ apolloClient });
  };

  handleApolloNetworkError = ({ networkError }: ErrorResponse) => {
    if (
      networkError &&
      "statusCode" in networkError &&
      networkError.statusCode === 401
    ) {
      this.state.authContainer.delAuth();
    }
  };

  handleUnauthenticatedError = (error: any) => {
    this.state.authContainer.delAuth();
  };

  render() {
    const { authContainer, apolloClient } = this.state;

    return (
      <div className="c-app">
        <UnstatedProvider inject={[authContainer]}>
          <ApolloProvider client={apolloClient}>
            <Router>
              <RouterErrorBoundary>
                <Switch>
                  <Route exact path="/login" component={LoginScene} />
                  <Route exact path="/logout" component={LogoutScene} />
                  <AuthRoute exact path="/" component={DashboardScene} />
                  <AuthRoute exact path="/user" component={UserScene} />
                  <AuthRoute exact path="/license" component={LicenseScene} />
                  <AuthRoute path="/scenario" component={ScenarioScene} />
                  <AuthRoute exact path="/session" component={SessionScene} />
                </Switch>
              </RouterErrorBoundary>
            </Router>
          </ApolloProvider>
        </UnstatedProvider>
      </div>
    );
  }
}

export default App;
